// Centralised axios instance for GasFlow Pro.
// All auth token handling and 401 redirect logic lives here — imported once by every component.
import axios from "axios";

export const BASE_URL = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const TOKEN_KEY = "gasflow_session_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const removeToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: BASE_URL });

// Attach Bearer token on every outgoing request
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401, except during the auth callback flow itself
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const path = window.location.pathname;
    const isAuthFlow = path === "/auth/callback";
    const isPublicPage = path === "/" || path === "/login";
    if (error.response?.status === 401 && !isAuthFlow && !isPublicPage) {
      const url = error.config?.url || "";
      if (!url.includes("/auth/session")) {
        removeToken();
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
